import { RecordColorEnum } from '../../../shared/enums/record-color.enum';
import { TagRecordCategoryEnum } from '../enums/tag-record-category.enum';

/**
 * Maps the category value to a color value which is used to style the record pill in the UI
 */
export function tagCategoryToColor(category: TagRecordCategoryEnum): string {
	switch (category) {
		case TagRecordCategoryEnum.CUSTOMER:
		case TagRecordCategoryEnum.LOCATION:
		case TagRecordCategoryEnum.SUPPLIER:
		case TagRecordCategoryEnum.AGENT:
		case TagRecordCategoryEnum.USER:
			return RecordColorEnum.BLUE;

		case TagRecordCategoryEnum.SHARED:
			return RecordColorEnum.SKY;

		case TagRecordCategoryEnum.TRANSACTION:
			return RecordColorEnum.AMBER;

		case TagRecordCategoryEnum.RENTAL_AGREEMENT:
			return RecordColorEnum.INDIGO;

		case TagRecordCategoryEnum.VEHICLE:
		case TagRecordCategoryEnum.VEHICLE_DAMAGE:
		case TagRecordCategoryEnum.VEHICLE_INSURANCE:
		case TagRecordCategoryEnum.VEHICLE_INSURANCE_CLAIM:
		case TagRecordCategoryEnum.VEHICLE_MAINTENANCE:
		case TagRecordCategoryEnum.VEHICLE_ROAD_TAX:
		case TagRecordCategoryEnum.VEHICLE_ROAD_WORTHY_CHECK:
			return RecordColorEnum.PURPLE;

		default:
			return RecordColorEnum.DEFAULT;
	}
}
